import { StyledLightningLinkCasino } from './style';
import { BundleProps } from 'utils/types';
import { Box } from '@mui/system';
import LightningLinkCasinoBundlePrice from './BundlePrice';
import { EBadgeType, EGradientDirection, EProductPriority } from 'utils/enums';
import { useEffect, useState } from 'react';
import { LightningLinkMainProduct } from './Products/MainProduct';
import { LightningLinkSubProduct } from './Products/SubProduct';
import { LightningLinkSaleBadge } from 'components/Badge/Sale/LightningLinkSaleBadge';
import { TooltipTemplate } from 'components/TooltipTemplate';
import { IExtendedTooltipProps } from 'components/TooltipTemplate/types';
import { BadgeData } from 'components/Badge/types';
const tooltipIcon =
  'https://media-dev.appcharge.com/media/6683d66f3ad9e626ecc051f5/1724936979813__75209c47-b991-4515-a23b-c3bd7ed7fa2a';

export const LightningLinkBundle: React.FC<BundleProps> = ({
  price,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#406cf9',
    colorTwo: '#6449ff',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  badges = [],
  bundleButtonColor,
  bundleButtonTextColor,
  salePercentage = 0,
  fontFamily,
  salePercentageDisplayType,
  tooltipLoadCallback,
}) => {
  const [emblemBadge, setEmblemBadge] = useState<any>(null);
  const [tooltipContent, setTooltipContent] =
    useState<IExtendedTooltipProps | null>(null);
  const [mainProduct, setMainProduct] = useState<any>(null);
  const [subProduct, setSubProduct] = useState<any>(null);
  const [isMainFirst, setIsMainFirst] = useState<boolean>(true);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadge(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadge(null);
    }
  }, [badges]);

  useEffect(() => {
    setMainProduct(
      productList.find((product) => product.priority === EProductPriority.MAIN),
    );
    setSubProduct(
      productList.find((product) => product.priority === EProductPriority.SUB),
    );
  }, [productList, tooltipLoadCallback]);

  useEffect(() => {
    if (
      mainProduct &&
      subProduct &&
      productList[0].priority === EProductPriority.SUB
    ) {
      setIsMainFirst(false);

      if (subProduct.strokedSaleQuantity) {
      }
    }

    if (mainProduct?.rarityProductInfo?.tooltip?.length > 0) {
      const tooltip = mainProduct.rarityProductInfo.tooltip;
      setTooltipContent({
        sections: tooltip,
        titleImg: mainProduct?.images?.product,
        title: mainProduct?.displayName || '',
        tooltipLoadCallback: tooltipLoadCallback,
      });
    }
  }, [mainProduct, subProduct]);

  // ACDEV-8957: Undo this PR this logic after we can have stroked for second product
  useEffect(() => {
    if (!isMainFirst && subProduct.strokedSaleQuantity) {
      setMainProduct((prev: any) => ({
        ...prev,
        strokedSaleQuantity: subProduct.strokedSaleQuantity,
      }));
    }
  }, [isMainFirst, mainProduct]);

  return (
    <StyledLightningLinkCasino
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      fontFamily={fontFamily}
      className="lightning-link-bundle"
    >
      {emblemBadge && (
        <div className="lightning-link-bundle__emblem-badge">
          <img alt={'emblem-badge'} src={emblemBadge.imageUrl} />
        </div>
      )}
      {salePercentage > 0 && (
        <LightningLinkSaleBadge
          salePercentage={salePercentage}
          salePercentageDisplayType={salePercentageDisplayType}
        />
      )}
      {tooltipContent && (
        <TooltipTemplate
          buttonStyle={{
            position: 'absolute',
            right: '8px',
            marginTop: '2px',
            zIndex: 2,
            cursor: 'pointer',
          }}
          content={tooltipContent}
          templateTooltipStyle={{
            background: '#3E2893',
            minWidth: 160,
            borderRadius: '7px',
            zIndex: '5',
            padding: '8px',
          }}
        >
          <img
            className={'tooltip-icon'}
            src={tooltipIcon}
            alt={'tooltip-icon'}
          ></img>
        </TooltipTemplate>
      )}
      {isMainFirst ? (
        <Box className={'lightning-link-bundle__products-container'}>
          {mainProduct && (
            <LightningLinkMainProduct
              mainProduct={mainProduct}
              salePercentage={salePercentage}
            />
          )}
          {subProduct && (
            <LightningLinkSubProduct
              subProduct={subProduct}
              tooltipLoadCallback={tooltipLoadCallback}
            />
          )}
        </Box>
      ) : (
        <Box className={'lightning-link-bundle__products-container'}>
          {subProduct && (
            <LightningLinkSubProduct
              subProduct={subProduct}
              tooltipLoadCallback={tooltipLoadCallback}
            />
          )}
          {mainProduct && (
            <LightningLinkMainProduct
              mainProduct={mainProduct}
              salePercentage={salePercentage}
            />
          )}
        </Box>
      )}
      <LightningLinkCasinoBundlePrice
        price={price}
        bundleButtonColor={bundleButtonColor}
        bundleButtonTextColor={bundleButtonTextColor}
        fontFamily={fontFamily}
      ></LightningLinkCasinoBundlePrice>
    </StyledLightningLinkCasino>
  );
};
